import React from 'react';
import { observer } from 'mobx-react';
import { useMst } from '../../../internal';
import { Button } from '../../../components/UI/buttons/regular/Button';
import styles from './KreirajOdgovor.module.scss';

export const KreirajOdgovor = observer((): JSX.Element => {
  const { currentPage } = useMst();

  return (
    <div className={styles.PageContainer}>
      <h2 className={styles.Title}>Novi odgovor</h2>

      {(currentPage.questionText || currentPage.questionImage) && (
        <div className={styles.QuestionContext}>
          {currentPage.questionText && (
            <p className={styles.QuestionText}>
              <span className={styles.QuestionLabel}>Pitanje:</span>{' '}
              {currentPage.questionText}
            </p>
          )}
          {currentPage.questionImage && (
            <img
              className={styles.QuestionImage}
              src={currentPage.questionImageUrl}
              alt="Slika pitanja"
            />
          )}
        </div>
      )}

      <div className={styles.Form}>
        <div className={styles.Field}>
          <label htmlFor="answerText">Tekst odgovora *</label>
          <input
            id="answerText"
            type="text"
            value={currentPage.answerText}
            onChange={(e) => currentPage.setAnswerText(e.target.value)}
          />
        </div>

        <div className={styles.Field}>
          <label htmlFor="orderNumber">Redosled</label>
          <input
            id="orderNumber"
            type="number"
            min={0}
            value={currentPage.orderNumber}
            onChange={(e) => currentPage.setOrderNumber(Number(e.target.value))}
          />
        </div>

        <div className={styles.CheckboxField}>
          <input
            id="isCorrect"
            type="checkbox"
            checked={currentPage.isCorrect}
            onChange={(e) => currentPage.setIsCorrect(e.target.checked)}
          />
          <label htmlFor="isCorrect">Tačan odgovor</label>
        </div>

        <div className={styles.Actions}>
          <Button
            onClick={() => currentPage.submit()}
            disabled={!currentPage.answerText.trim()}
          >
            Sačuvaj
          </Button>
          <Button onClick={() => currentPage.navigateBack()}>Otkaži</Button>
        </div>
      </div>
    </div>
  );
});
